module.exports = __webpack_public_path__ + "media/Images/logo-one-digital-002-50c8880d8e7c2287f5c26a69ccfb7993.png";